/**
 * Everything to do with the link an operator sends a farmer.
 *
 * The links are built from the browser's own origin, so the same code works on
 * the demo laptop (http://localhost:5173) and on the real domain without a
 * build-time setting. Set VITE_PUBLIC_ORIGIN when the public site sits on a
 * different host from the staff app.
 */
const configured = (import.meta.env?.VITE_PUBLIC_ORIGIN || '').replace(/\/$/, '')

export const publicOrigin = () =>
  configured || (typeof window !== 'undefined' ? window.location.origin : '')

export const publicDirectoryUrl = () => `${publicOrigin()}/hatcheries`
export const publicHatcheryUrl = id => `${publicOrigin()}/hatcheries/${id}`

/** A hatchery-filtered directory link — useful when the desk pushes one place. */
export const publicSearchUrl = q =>
  `${publicDirectoryUrl()}?q=${encodeURIComponent(q || '')}`

export const MESSAGES = [
  {
    key: 'en',
    label: 'English',
    body: url => `Namaste 🙏

Aqua Platform — shrimp seed desk for the Tuni – Kakinada – U. Kothapalli belt.

See the hatcheries with seed ready and pick the one you want:
${url}

Then tap "Request seed" on that hatchery, or call our desk. We book it for you, and a 100-animal sample reaches your pond 2 days before stocking for the 24-hour survival test. Seed ships only if the sample passes.`
  },
  {
    key: 'te',
    label: 'తెలుగు (Telugu)',
    body: url => `నమస్తే 🙏

ఆక్వా ప్లాట్‌ఫారమ్ — తుని – కాకినాడ – ఉ. కొత్తపల్లి ప్రాంతానికి రొయ్య సీడ్ డెస్క్.

సీడ్ సిద్ధంగా ఉన్న హేచరీలను చూసి, మీకు కావలసినది ఎంచుకోండి:
${url}

తర్వాత ఆ హేచరీలో "Request seed" నొక్కండి, లేదా మా డెస్క్‌కి ఫోన్ చేయండి. బుకింగ్ మేము చేస్తాము. స్టాకింగ్‌కి 2 రోజుల ముందు 100 పిల్లల శాంపిల్ మీ చెరువుకు వస్తుంది — 24 గంటల సర్వైవల్ టెస్ట్ పాస్ అయితేనే సీడ్ పంపబడుతుంది.`
  },
  {
    key: 'short',
    label: 'Short SMS',
    body: url => `Aqua Platform: hatcheries with seed ready — ${url} . Pick one and tap Request seed, or call the desk. Sample test before every dispatch.`
  }
]

export const whatsappUrl = (text, phone) => {
  const base = phone
    ? `https://wa.me/${String(phone).replace(/[^0-9]/g, '')}`
    : 'https://wa.me/'
  return `${base}?text=${encodeURIComponent(text)}`
}

export const smsUrl = (text, phone) =>
  `sms:${phone || ''}?&body=${encodeURIComponent(text)}`
